export default __webpack_public_path__ + "687ac2d4ce12d082fe5130645446797e.woff";